import Toggle from '../../../components/Toggle';
import { useState } from 'react';
import { DraggableModal } from '../../../components/ui/DraggableModal';
import type { ProSearchData } from '../../../services/search.service';
import { capacityDate, isOpen, isRequestForPro, useCapacityPreview, type OrderContext } from './model';
import { buttonClass, PreviewNotice, primaryClass, RequestForm } from './CapacityForms';
import { LinkCapacityDialog } from './CapacityBoard';
export default function CapacitySearchAction({
  getRows,
  link = false
}: {
  getRows: () => ProSearchData[];
  link?: boolean;
}) {
  const {
    requests
  } = useCapacityPreview();
  const [orders, setOrders] = useState<OrderContext[] | null>(null);
  const [selected, setSelected] = useState<string[]>([]);
  const [next, setNext] = useState(false);
  const close = () => {
    setOrders(null);
    setNext(false);
    setSelected([]);
  };
  const blocked = (o: OrderContext) => !link && (!!o.appointment || requests.some(r => isOpen(r) && isRequestForPro(r, o.pro)));
  return <><button className={buttonClass} onClick={() => {
      const rows = [...new Map(getRows().filter(r => /^\d+$/.test(String(r.pronumber))).map(r => [String(r.pronumber), r])).values()];
      setOrders(rows.map(r => ({
        pro: String(r.pronumber),
        customer: r.customerName || '',
        market: r.terminal || '',
        move: r.moveType || '',
        container: r.container || '',
        size: `${r.size || ''} ${r.equipType || ''}`.trim(),
        pickup: r.pickupFrom || '',
        delivery: r.deliverTo || '',
        cutoff: capacityDate(r.cutoff || ''),
        lfd: capacityDate(r.lfd || ''),
        appointment: r.delivAppt || undefined
      })));
    }}>{link ? 'Link to capacity check' : 'Request Capacity'}</button>
    {orders && !next && <DraggableModal isOpen onClose={close} title={link ? 'Select PROs to link' : 'Select PROs for capacity requests'} width={800} headerClassName="border-b border-theme-border-primary bg-panel text-heading" footer={<button className={primaryClass} disabled={!selected.length} onClick={() => setNext(true)}>Continue with {selected.length} PROs</button>}><PreviewNotice /><div className="mb-3 flex gap-2"><button className={buttonClass} onClick={() => setSelected(orders.filter(o => !blocked(o)).map(o => o.pro))}>Select eligible</button><button className={buttonClass} onClick={() => setSelected([])}>Clear</button></div>{orders.map(o => <label key={o.pro} className="mb-2 flex items-center gap-3 rounded border border-theme-border-primary p-3 text-sm"><Toggle size="sm" ariaLabel={`Select PRO ${o.pro}`} disabled={blocked(o)} checked={selected.includes(o.pro)} onChange={checked => setSelected(checked ? [...selected, o.pro] : selected.filter(p => p !== o.pro))} /><span>{o.pro} · {o.customer} · {o.market}{blocked(o) && <span className="ml-2 text-muted">{o.appointment ? 'Delivery appointment set' : 'Open request exists'}</span>}</span></label>)}{!orders.length && <p>No eligible numeric PROs in these results.</p>}</DraggableModal>}
    {orders && next && (link ? <LinkCapacityDialog orders={orders.filter(o => selected.includes(o.pro))} onClose={close} /> : <RequestForm orders={orders.filter(o => selected.includes(o.pro))} onClose={close} />)}
  </>;
}
